// import React from "react";
// import { QRCodeSVG } from "qrcode.react";
// import A1 from "../Images/WhatsApp Image 2026-01-20 at 12.46.23 PM.jpeg";
// import UFTAA from "../Images/UFTAA.png";
// import IATA from "../Images/IATA.jpeg";
// import TAAIIDBGIMG from "../Images/TAAIIDBGIMG.png";

// const mmToPx = (mm) => (mm * 96) / 25.4;

// const cardDimensions = {
//     width: mmToPx(84.5),
//     height: mmToPx(53.5),
// };

// const MembershipCard = ({ agency, rep }) => {
//     const colors = {
//         primary: "#2c2f7a",
//         textDark: "#000000",
//         textLight: "#ffffff",
//     };

//     const profileLinkR1 = agency.card_URL_rep1
//         ? `https://taaiapp.emedha.in/cardurl/${agency.card_URL_rep1}`
//         : "";

//     const profileLinkR2 = agency.card_URL_rep2
//         ? `https://taaiapp.emedha.in/cardurl/${agency.card_URL_rep2}`
//         : "";

//     return (
//         <div id={`card-${rep.key}`} style={{ width: cardDimensions.width, height: cardDimensions.height, fontFamily: "'Swiss 721BT', 'Swiss 721 Cn BT', sans-serif", color: colors.primary, boxSizing: "border-box", overflow: "hidden", borderRadius: "8px", border: "1px solid #ccc", display: "flex", flexDirection: "column", position: "relative", backgroundImage: `url(${TAAIIDBGIMG})`, backgroundSize: "cover", backgroundPosition: "center", }}>
//             <div style={{ height: "22%", minHeight: "22%", display: "flex", alignItems: "center", padding: "0 6%", fontFamily: "'Swiss 721 Cn BT', sans-serif", fontWeight: "700", }}>
//                 <img src={A1} alt="TAAI" style={{ height: "90%", objectFit: "contain" }} />
//                 <div style={{ marginLeft: "auto", fontSize: "1.1rem", letterSpacing: "1px", }}>TAAI TRAVEL PASS ID</div>
//             </div>
//             <div style={{ display: "flex", flex: 1, padding: "6% 4%", gap: "4%", alignItems: "center", overflow: "hidden", fontFamily: "'Swiss 721BT', sans-serif", fontSize: "0.58rem", lineHeight: 1.3, }}>
//                 <div style={{ width: "28%", display: "flex", flexDirection: "column" }}>
//                     <div style={{ width: "100%", height: "85px", border: "1px solid #b6c6e3", borderRadius: "2px", overflow: "hidden", backgroundColor: "#fff", }}>
//                         <img src={rep.photo} alt="Rep" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                     </div>
//                     <div style={{ marginTop: "2px", lineHeight: "1.1" }}>
//                         <div style={{ fontSize: rep.name.length > 15 ? "0.3rem" : "0.5rem", fontWeight: "700", color: colors.primary, textTransform: "uppercase", }}>
//                             {rep.name}
//                         </div>
//                         <div style={{ fontSize: rep.name.length > 15 ? "0.3rem" : "0.5rem", color: "#252525" }}>
//                             {rep.designation}
//                         </div>
//                     </div>
//                 </div>
//                 <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "flex-start", textAlign: "right", marginBottom: "25px", }}>
//                     <div style={{ fontSize: agency.agency_name.length > 20 ? "0.60rem" : "0.80rem", fontWeight: "700", color: colors.primary, fontFamily: "'Swiss 721 Cn BT', sans-serif", marginBottom: "1px", }}>
//                         {agency.agency_name}
//                     </div>
//                     <div style={{ fontWeight: "700", color: "#252525" }}>
//                         {agency.category} – Member ID : {agency.membership_id} ({agency.year_of_joining})
//                     </div>
//                     <div style={{ fontWeight: "700", color: "#252525" }}>
//                         {agency.city}, {agency.state}, {agency.country} - {agency.pin_code}
//                     </div>
//                     <div style={{ marginTop: "2px", fontWeight: "700", color: "#252525" }}>
//                         E: {rep.email}
//                         <br />
//                         M: {rep.mobile}
//                     </div>
//                 </div>
//             </div>

//             <div style={{ flexShrink: 0, height: "25%", minHeight: "25%", borderTop: "1px solid transparent", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "top", color: "white", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 4%", fontSize: "0.55rem", boxSizing: "border-box", fontFamily: "'Swiss 721BT', sans-serif", }}>
//                 <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//                     <div style={{ fontSize: rep.name.length > 15 ? "0.3rem" : "0.5rem", color: "#252525" }}>BG: {rep.blood_group}</div>
//                     <div style={{ fontWeight: "bold", marginBottom: "12px" }}>www.taai.in</div>
//                 </div>
//                 <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
//                     <div style={{ width: "52px", marginBottom: "20px", height: "52px", backgroundColor: "white", padding: "2px", borderRadius: "2px", display: "flex", alignItems: "center", justifyContent: "center", }}><QRCodeSVG value={rep.key === "rep1" ? profileLinkR1 : profileLinkR2} size={50} level="L" /></div>
//                     <div style={{ backgroundColor: "white", borderRadius: "5px", padding: "4px", display: "flex", alignItems: "center", justifyContent: "center", }}>
//                         <img src={IATA} alt="IATA" style={{ height: "30px", width: "50px" }} />
//                     </div>
//                     <div style={{ backgroundColor: "white", borderRadius: "5px", padding: "4px", display: "flex", alignItems: "center", justifyContent: "center", }}>
//                         <img src={UFTAA} alt="UFTAA" style={{ height: "30px" }} />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MembershipCard;








// import React from "react";
// import { QRCodeSVG } from "qrcode.react";
// import TAAILogo from "../Images/taailogo.jpeg";
// import FRONT from "../Images/front.png";
// import UFTAA from "../Images/UFTAA.png";

// const mmToPx = (mm) => (mm * 96) / 25.4;

// const card = {
//     width: mmToPx(84.5),
//     height: mmToPx(53.5),
// };

// const MembershipCard = ({ agency, rep }) => {
//     const profileLink =
//         rep.key === "rep1"
//             ? `https://taaiapp.emedha.in/cardurl/${agency.card_URL_rep1}`
//             : `https://taaiapp.emedha.in/cardurl/${agency.card_URL_rep2}`;

//     return (
//         <div id={`card-${rep.key}`} style={{ width: card.width, height: card.height, borderRadius: "10px", overflow: "hidden", fontFamily: "Montserrat, sans-serif", backgroundImage: `url(${FRONT})`, backgroundSize: "cover", padding: "6px 8px", boxSizing: "border-box", position: "relative", }}>
//             {/* HEADER */}
//             <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "4px", }}>
//                 <div style={{ textAlign: "right", padding: '10px' }}>
//                     <img src={TAAILogo} alt="TAAI" style={{ height: "38px", borderRadius: "4px" }} />
//                     <div style={{ fontWeight: "700", fontSize: "1.42rem", color: "#ffffff", marginTop: "1px", }}>
//                         TAAI TRAVEL ID
//                     </div>
//                 </div>
//             </div>

//             {/* BODY */}
//             <div style={{ display: "flex", padding: '5px', marginTop: '-20px' }}>
//                 {/* LEFT */}
//                 <div style={{ width: "36%", display: "flex", flexDirection: "column", alignItems: "center", }}>
//                     <div style={{ width: "100px", height: "100px", borderRadius: "50%", overflow: "hidden", border: "2px solid #ffffff", backgroundColor: "#fff", marginTop: "-55px", }}>
//                         <img src={rep.photo} alt="Rep" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                     </div>

//                     <div style={{ fontSize: "0.58rem", fontWeight: "700", marginTop: "4px", textAlign: "center", }}>
//                         {rep.name}
//                     </div>

//                     <div style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 500, textAlign: "center" }}>
//                         {rep.designation}
//                     </div>
//                 </div>

//                 {/* RIGHT */}
//                 <div style={{ width: "64%", fontSize: "0.56rem", color: "#000", paddingLeft: "8px", lineHeight: "1.4", textAlign: "right", display: "flex", flexDirection: "column", alignItems: "flex-end", }}>
//                     <div style={{ fontWeight: "700", fontSize: "0.66rem", marginBottom: "2px", }}>
//                         {agency.agency_name}
//                     </div>

//                     <div style={{ marginBottom: "2px", fontFamily: "Montserrat, sans-serif", fontWeight: 500 }}>
//                         Active – Member ID : {agency.membership_id} (
//                         {agency.year_of_joining})
//                     </div>

//                     <div style={{ marginBottom: "4px", fontFamily: "Montserrat, sans-serif", fontWeight: 500 }}>
//                         {agency.city}, {agency.state}, {agency.country} – {agency.pin_code}
//                     </div>

//                     <div style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 500 }}>
//                         E: {rep.email}
//                         <br />
//                         M: {rep.mobile}
//                     </div>
//                     <div>
//                         <img src={UFTAA} alt="UFTAA" style={{ height: "20%", objectFit: "cover" }} />
//                     </div>
//                 </div>

//             </div>

//             {/* QR CODE – CENTERED NEAR FOOTER */}
//             <div style={{ position: "absolute", bottom: "26px", left: "50%", transform: "translateX(-50%)", background: "#ffffff", padding: "4px", border: "1px solid #ccc", }}>
//                 <QRCodeSVG value={profileLink} size={32} />
//             </div>

//             {/* FOOTER */}
//             <div style={{ position: "absolute", bottom: "6px", left: 0, right: 0, textAlign: "center", fontSize: "0.56rem", fontWeight: "700", color: "#ffffff", }}>
//                 www.taai.in
//             </div>
//         </div>
//     );
// };

// export default MembershipCard;






import React from "react";
import { QRCodeSVG } from "qrcode.react";
import TAAILogo from "../Images/taailogo.jpeg";
import FRONT from "../Images/front.png";
import UFTAA from "../Images/UFTAA.png";

// Convert mm to px for print-accurate sizing
const mmToPx = (mm) => (mm * 96) / 25.4;

const card = {
    width: mmToPx(84.5),
    height: mmToPx(53.5),
};

// Montserrat font styles
const FONT = {
    montBold: { fontFamily: "Montserrat, sans-serif", fontWeight: 700 },
    montRegular: { fontFamily: "Montserrat, sans-serif", fontWeight: 400 },
};

const MembershipCard = ({ agency, rep }) => {
    const profileLink =
        rep.key === "rep1"
            ? `https://taaiapp.emedha.in/cardurl/${agency.card_URL_rep1}`
            : `https://taaiapp.emedha.in/cardurl/${agency.card_URL_rep2}`;

    return (
        <div id={`card-${rep.key}`} style={{ width: card.width, height: card.height, borderRadius: "10px", overflow: "hidden", fontFamily: "Montserrat, sans-serif", backgroundImage: `url(${FRONT})`, backgroundSize: "cover", padding: "6px 8px", boxSizing: "border-box", position: "relative", }}>
            {/* HEADER */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "4px" }}>
                <div style={{ textAlign: "right", padding: "10px" }}>
                    <img src={TAAILogo} alt="TAAI" style={{ height: "38px", borderRadius: "4px" }} />
                    <div style={{ ...FONT.montBold, fontSize: "21.5px", color: "#ffffff", marginTop: "1px", }}>
                        TAAI TRAVEL ID
                    </div>
                </div>
            </div>

            {/* BODY */}
            <div style={{ display: "flex", padding: "5px", marginTop: "-20px" }}>
                {/* LEFT */}
                <div style={{ width: "36%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div style={{ width: "100px", height: "100px", borderRadius: "50%", overflow: "hidden", border: "2px solid #ffffff", backgroundColor: "#fff", marginTop: "-55px", }}>
                        <img src={rep.photo} alt="Rep" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </div>
                    <div style={{ ...FONT.montBold, fontSize: "10px", marginTop: "4px", textAlign: "center", }}>
                        {rep.name}
                    </div>
                    <div style={{ ...FONT.montBold, fontSize: "9px", textAlign: "center", }}>
                        {rep.designation}
                    </div>
                </div>

                {/* RIGHT */}
                <div style={{ width: "64%", fontSize: "6px", color: "#000", paddingLeft: "8px", lineHeight: "1.4", textAlign: "right", display: "flex", flexDirection: "column", alignItems: "flex-end", }}>
                    <div style={{ ...FONT.montBold, fontSize: "8px", marginBottom: "2px", }}>
                        {agency.agency_name}
                    </div>
                    <div style={{ ...FONT.montRegular, fontSize: "7px", marginBottom: "2px" }}>
                        Active – Member ID : {agency.membership_id} ({agency.year_of_joining})
                    </div>
                    <div style={{ ...FONT.montRegular, fontSize: "7px", marginBottom: "2px" }}>
                        {agency.city}, {agency.state}, {agency.country} – {agency.pin_code}
                    </div>
                    <div style={{ ...FONT.montRegular, fontSize: "7px", marginBottom: "2px" }}>
                        E: {rep.email}
                    </div>
                    <div style={{ ...FONT.montRegular, fontSize: "7px", marginBottom: "2px" }}>
                        M: {rep.mobile}
                    </div>
                    <div>
                        <img src={UFTAA} alt="UFTAA" style={{ height: "20%", objectFit: "cover" }} />
                    </div>
                </div>
            </div>

            {/* QR CODE */}
            <div style={{ position: "absolute", bottom: "26px", left: "50%", transform: "translateX(-50%)", background: "#ffffff", padding: "4px", border: "1px solid #ccc", }}>
                <QRCodeSVG value={profileLink} size={32} />
            </div>

            {/* FOOTER */}
            <div style={{ position: "absolute", bottom: "6px", left: 0, right: 0, textAlign: "center", ...FONT.montBold, fontSize: "7px", color: "#ffffff", }}>
                www.taai.in
            </div>
        </div>
    );
};

export default MembershipCard;
